// extracted by mini-css-extract-plugin
export var background = "PageBg-module--background--dca0a";
export var bgWrapper = "PageBg-module--bgWrapper--8b39e";